module.exports = __webpack_public_path__ + "img/lotnisko.6b8766d1.jpg";